import * as yup from 'yup';
import { CameFromType } from 'common/constants';
import { getRequiredErrorMessage } from 'common/utils/validation';

export const cameFromFieldsSchema = {
  cameFromValue: yup
    .string()
    .nullable()
    .when(['optional', 'cameFromType', 'cameFromIndicatorId'], {
      is: (optional, type, id) =>
        !!id && !optional && type !== CameFromType.NoInput && type !== CameFromType.ReferralList,
      then: yup
        .string()
        .nullable()
        .required(getRequiredErrorMessage),
    }),
  cameFromIndicatorId: yup
    .string()
    .nullable()
    .required(getRequiredErrorMessage),
  referralMember: yup
    .object()
    .nullable()
    .when(['optional', 'cameFromType', 'cameFromIndicatorId'], {
      is: (optional, type, id) => !!id && type === CameFromType.ReferralList && !optional,
      then: yup
        .object()
        .nullable()
        .required(getRequiredErrorMessage),
    }),
};
